<template>
    <div id="LqsAnalyser">
        <div class="">
            <div class="row datepickerwrap card">
                <div class="col-12 p-0">
                    <div class="">
                        <!-- <div class="graphHeading">Listing Analyzer Preview</div> -->
                        <div class="flex-start">
                            <div class="">
                                <div class="customInput">
                                    <!-- <span >{{inputSearchkey}}</span> -->
                                    <input :class="{ danger: isInputEmpty, customInput: !isInputEmpty }"
                                        @input="changeInputState" placeholder="Enter product ASIN" v-model="inputSearchkey"
                                        required />
                                </div>
                                <div class="errorMassage" v-if="isInputEmpty">Pls Enter ASIN Number</div>
                            </div>
                            <div class="ml-2">
                                <button class="btn primarycolor disabled"  type="button"  role="button" aria-disabled="true" >
                                    <span>Submit</span>
                                </button>
                            </div>
                            <div class="ml-2">
                                <button class="btn primarycolor disabled"  type="button"  role="button" aria-disabled="true" >
                                    <span>Schedule</span>
                                </button>
                            </div>
                            <div class="ml-2">
                                <router-link to="/my-asins-global" style="text-decoration: none">
                                    <button class="btn primarycolor" type="button">
                                        <span>My ASINs</span>
                                    </button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row datepickerwrap card" v-if="isScheduleOpen">
                <div class="col-12 p-0">
                    <div class="graphHeading mb-2">Schedule ASIN</div>
                    <div class=" ">
                        <div class="row mb-2">
                            <!-- <div class="col-1 ">
                 E-mail:
                </div> -->
                            <div class="col-5">
                                <input type="email" placeholder="Enter Email" style="width: 100%" class="customInput"
                                    v-model="schedule.email" pattern=".+@globex\.com" required />
                            </div>
                        </div>
                        <div class="row">
                            <!-- <div  class="col-1"> 
                  ASIN : 
                </div> -->
                            <div class="col-5">
                                <div class="d-flex justify-content-start">
                                    <input class="customInput" placeholder="Enter ASIN (press enter for multiple ASINs)"
                                        style="width: 100%" v-model="schedule.ASIN" @keyup="addASIN" />
                                    <button class="btn primarycolor ml-2" type="button" @click="addASINButton">
                                        <span>+</span>
                                    </button>
                                </div>
                                <div class="mb-3">
                                    <b-badge pill variant="success" class="mr-1 asinBadge p-1"
                                        v-for="(d, i) in schedule.ASINs" :key="d">
                                        <span>{{ d }}</span>
                                        <b-badge variant="light" @click="removeASIN(i)" class="ml-2 crossIcon"
                                            title="remove">x</b-badge>
                                    </b-badge>
                                </div>
                            </div>
                        </div>
                        <div class="datebox">
                            <button class="btn primarycolor" disabled type="button" @click="postLqsBulkSchedule">
                                <span>Submit</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <ASINResult/> -->
            <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <div class="row" id="LqsAnalyserCard" v-if="viewLqsGraph">
                <div class="col-md-12 mycols">
                    <div class="card datepickerwrap">
                        <!-- <LgsCard :viewLqsGraph="viewLqsGraph" :viewLqsListingdata="viewLqsListingdata" /> -->
                        <div style="margin: 0" class="space-between">
                            <div class="graphHeading">
                                Listing Quality Score (LQS) Analysis
                                <span class="textColor">({{ asin }})</span>
                            </div>
                            <div>
                                <span class="ml-2 screenshot-btn" @click="takeScreenshot"><i
                            class="fa fa-download cursor-pointer text-primary bg-black px-2 py-1 border border-success rounded"
                            aria-hidden="true"></i>
                            </span></div>
                        </div>
                        <div class="row p-2">
                            <div class="productCart">
                                <div class="productImg">
                                    <img :src="viewLqsListingdata.product_meta.product_image" />
                                </div>
                                <div class="ml-2">
                                    <a :href="viewLqsListingdata.product_meta.product_link" target="_blanck"
                                        class="cursor-pointer textColor product-title" syte>{{
                                            viewLqsListingdata.product_meta.product_name }}</a>
                                </div>
                            </div>
                        </div>

                        <div class="row p-2">
                            <div class="col-2">
                                <div class="border rounded">
                                    <!-- <div class="text-center fs-1 mt-3 secondaryHeading">Listing Quality Score 
                        <i class="fa fa-info-circle textColor" aria-hidden="true"></i>
                    </div> -->
                                    <div style="text-align: center">
                                        <highcharts style="width: 100%" :options="gaugeChartData"></highcharts>
                                    </div>
                                    <div class="text-center graphCount">{{ viewLqsGraph }}</div>
                                </div>
                            </div>
                            <div class="col-10">
                                <div class="row">
                                    <div class="col-4 sideBorder">
                                        <div class="secondaryHeading mb-2">Copy Breakdown</div>
                                        <div class="space-between-header"
                                            v-for="(row, i) in viewLqsListingdata.copy_breakdown" :key="'lqs_cb' + i">
                                            <div class="textColor" style="text-transform: capitalize">
                                                <i class="fa fa-circle trueIcon mr-2" aria-hidden="true"
                                                    :class="{ falseIcon: row.status == false }"></i>
                                                {{ row.label }}
                                                <i class="fa fa-info-circle cursor-pointer" aria-hidden="true"
                                                    :title="row.label"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-4 sideBorder">
                                        <div class="secondaryHeading mb-2">Media Breakdown</div>
                                        <div class="space-between-header"
                                            v-for="(row, i) in viewLqsListingdata.media_breakdown" :key="'lqs_cb' + i">
                                            <div class="textColor" style="text-transform: capitalize">
                                                <i class="fa fa-circle trueIcon mr-2" aria-hidden="true"
                                                    :class="{ falseIcon: row.status == false }"></i>
                                                {{ row.label }}
                                                <i class="fa fa-info-circle cursor-pointer" aria-hidden="true"
                                                    :title="row.label"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="secondaryHeading mb-2">Review Breakdown</div>
                                        <div class="space-between-header"
                                            v-for="(row, i) in viewLqsListingdata.review_breakdown" :key="'lqs_cb' + i">
                                            <div class="textColor" style="text-transform: capitalize">
                                                <i class="fa fa-circle trueIcon mr-2" aria-hidden="true"
                                                    :class="{ falseIcon: row.status == false }"></i>
                                                {{ row.label }}
                                                <i class="fa fa-info-circle cursor-pointer" aria-hidden="true"
                                                    :title="row.label"></i>
                                            </div>
                                        </div>
                                        <div class="singatureLogo">
                                            <div style="font-size: 14px" class="text-secondary">Powered By</div>
                                            <img src="img/brand/brand_logos/Logos-18.png" width="72" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- request ASINs -->
            <div class="row datepickerwrap card">
                <div class="col-12 p-0">
                    <div class="space-between">
                        <div class="graphHeading">Requested ASINs</div>
                        <date-range-picker v-model="dateRange" opens="left" :autoApply="true"
                            :locale-data="{ format: 'yyyy-mm-dd' }" @update="dateChange" style="border: none">
                        </date-range-picker>
                    </div>
                    <div class="card mt-2" style="padding: 0px !important">
                        <div v-if="!viewLqsRequestData.data" class="no-data" style="">No Data</div>
                        <table class="" id="lqsTable">
                            <thead>
                                <tr>
                                    <th scope="col" v-for="th of viewLqsRequestData.header" :key="th.key" class="p-2">
                                        {{ th.label }}
                                    </th>
                                    <th v-if="viewLqsRequestData.data">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="tr3row" v-for="(row, i) in viewLqsRequestData.data" :key="i">
                                    <td v-for="(d, j) in viewLqsRequestData.header" :key="j">
                                        <router-link :to="'/req-asins-detailed-global/' +
                                            row.request_id +
                                            '/' +
                                            dateRange.startDate +
                                            '/' +
                                            dateRange.endDate
                                            " v-if="d.key == 'request_id'">
                                            <div style="text-transform: capitalize">
                                                {{ row[d.key] }}
                                            </div>
                                        </router-link>
                                        <div v-else style="text-transform: capitalize">{{ row[d.key] }}</div>
                                    </td>
                                    <td>
                                        <b-button variant="outline-danger" class="px-3 py-1"
                                            @click="confirmDeleteRequestASIN(row.request_id)"><i
                                                class="fa fa-trash"></i></b-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <b-modal title="Delete Requested ASIN" v-model="deleteRequestModal" class="container-modal-ASIN">
            <div class="modal-delete-content d-flex align-items-start mb-2">
                <div class="delete-alert text-center rounded-circle px-2 mr-3">&#9888;</div>
                <!-- <div>Do you want to delete the request ASIN ?</div> -->
                <div>You're going to delete this request ASIN.<br>Are you sure ?</div>
            </div>
            <div class="d-flex justify-content-end">
                <b-button @click="closeConfirmModal" class="btn primarycolor">No, Keep It.</b-button>
                <button @click="deleteRequestASIN" :disabled="deleteRequestLoader"
                    class="btn primarycolor px-3 py-1 ml-2 d-flex align-items-center delete-requestBtn"
                    style="background-color: var(--red)">
                    <b-spinner small class="mr-2" v-if="deleteRequestLoader"></b-spinner>
                    <span>Yes, Delete!</span>
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import LqsCard from "./LqsCard";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import html2canvas from 'html2canvas';

export default {
    name: "LqsAnalyser",
    components: { LqsCard, Datepicker },

    data: function () {
        return {
            gaugeChartData: {},
            viewLqsListingdata: {},
            inputSearchkey: "",
            viewLqsGraph: "",
            loader: false,
            asin: "",
            isInputEmpty: false,
            isScheduleOpen: false,
            isMyASINDataOpen: false,
            schedule: {
                email: "",
                ASIN: "",
                ASINs: [],
            },
            viewMyASINsData: {},
            viewLqsRequestData: {},
            dateRange: {
                startDate: moment().subtract(1, "month"),
                endDate: moment(),
            },
            intervalId: null,
            deleteRequestModal: false,
            storeDeleteRequestId: [],
            deleteRequestLoader: false
        };
    },

    mounted() {
        this.dataAPIs();

    },
    methods: {
        checkStatus() {
            this.intervalId = setInterval(() => {
                this.getLqsRequest(false)
            }, 10000);
        },
        destroyInterval() {
            if (this.viewLqsRequestData.data[0].status == 'Success' || this.viewLqsRequestData.data[0].status == 'failed') {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }

        },
        dataAPIs() {
            this.formatDates();
            this.getLqsRequest(true);
        },
        formatDates() {
            this.dateRange.startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
            this.dateRange.endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
        },
        dateChange() {
            this.formatDates();
            this.getLqsRequest(true);
        },
        addASIN() {
            let data = this.schedule.ASIN.trim();
            if (event.key != "Enter" || !data.length) {
                return false;
            }
            if (!this.validASIN(data)) {
                alert("please enter vaild ASIN");
                return false
            }
            if (!this.schedule.ASINs.includes(data)) {
                this.schedule.ASINs.push(data);
                this.schedule.ASIN = "";
            }
        },
        addASINButton() {
            let data = this.schedule.ASIN.trim();
            if (!this.validASIN(data)) {
                alert("please enter vaild ASIN");
                return false
            }
            if (!this.schedule.ASINs.includes(data)) {
                this.schedule.ASINs.push(data);
                this.schedule.ASIN = "";
            }
        },
        removeASIN(i) {
            this.schedule.ASINs.splice(i, 1);
        },

        // delete ASIN request
        confirmDeleteRequestASIN(reqId) {
            this.storeDeleteRequestId = []
            this.storeDeleteRequestId.push(reqId);
            this.deleteRequestModal = true;
        },

        closeConfirmModal() {
            this.storeDeleteRequestId = []
            this.deleteRequestModal = false;
        },

        deleteRequestASIN() {
            // pending
            let self = this;
            self.loader = false;
            self.deleteRequestLoader = true
            let payload = {
                job_ids: this.storeDeleteRequestId
            };
            const url = "/api/spider/deleterequests";
            self.$http
                .post(url, payload)
                .then((response) => {
                    self.deleteRequestLoader = false;
                    this.deleteRequestModal = false;
                    self.getLqsRequest(false);
                    self.storeDeleteRequestId = []
                    self.loader = false;
                    this.$bvToast.toast(response.data.data.message, {
                        title: response.data.data.summary,
                        autoHideDelay: 3000,
                        variant: "success"
                    });
                })
                .catch((err) => {
                    self.loader = false;
                    console.log("err");
                });
        },

        toggleScheduleForm() {
            this.isScheduleOpen = !this.isScheduleOpen;
        },
        toggleMyASINData() {
            this.isMyASINDataOpen = !this.isMyASINDataOpen;
        },
        changeInputState() {
            this.isInputEmpty = false;
        },

        async takeScreenshot() {
            let self = this
            let id = "#LqsAnalyserCard";
            let uniqueCardId = document.querySelector(id);
            let getScreenshotDiv = uniqueCardId.querySelector('.screenshot-btn');
            getScreenshotDiv.classList.add('screenshot-hide-btn');
            html2canvas(uniqueCardId, { useCORS: true }).then(function (canvas) {
                canvas.style.display = "none"
                document.body.appendChild(canvas);
                const image = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
                const a = document.createElement("a");
                a.setAttribute("download", `Weavr-LQS-${ self.asinData }.png`);
                a.setAttribute("href", image);
                a.click();
                getScreenshotDiv.classList.remove('screenshot-hide-btn');
            });
        },
        getLqsRequest(loader) {
            let self = this;
            self.loader = loader;
            let payload = {
                start: this.dateRange.startDate,
                end: this.dateRange.endDate,
            };
            const url = "/api/global_demo/viewrequest";
            self.$http
                .post(url, payload)
                .then((response) => {
                    // if(Object.keys(response.data.data.data).length)
                    self.viewLqsRequestData = response.data.data;
                    self.destroyInterval();
                    self.loader = false;
                })
                .catch((err) => {
                    self.loader = false;
                    console.log("err");
                });
        },

        postLqsBulkSchedule() {
            let self = this;
            // this.loader = true
            if (!this.validEmail(this.schedule.email) || !this.schedule.email) {
                alert("email id incorrect");
                return false;
            }
            if (this.schedule.ASIN) {
                if (this.validASIN(this.schedule.ASIN)) {
                    if (!this.schedule.ASINs.includes(this.schedule.ASIN)) {
                        this.schedule.ASINs.push(this.schedule.ASIN);
                    }
                } else {
                    alert("Please enter vaild ASIN");
                    return false
                }
            }
            if (!this.validASIN(this.schedule.ASIN) && this.schedule.ASINs.length == 0) {
                alert("Please enter vaild ASIN");
                return false
            }
            // else if()
            // self.loader = true;
            let payload = {
                asin_id: self.schedule.ASINs,
                email: self.schedule.email,
            };
            // console.log("check tdh payload", payload,this.schedule.ASINs)
            const url = "/api/global_demo/lqsscheduler";
            // console.log("check the payload", payload)
            self.$http
                .post(url, payload)
                .then((response) => {
                    self.getLqsRequest(true);
                    self.schedule.ASIN = ''
                    self.schedule.ASINs = [];
                    self.schedule.email = [];
                    self.checkStatus();
                    self.loader = false;
                    alert("Success");
                })
                .catch((err) => {
                    self.loader = false;
                    console.log("err");
                });
        },
        validEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },

        validASIN(ASIN) {
            var isASIN = /^(B[0-9A-Z]{2}\d{7}|[0-9A-Z]{10})$/;
            return isASIN.test(ASIN);
        },

        getLqsListingData() {
            let self = this;
            if (!this.inputSearchkey) {
                self.isInputEmpty = true;
                return false;
            }

            if (!this.validASIN(this.inputSearchkey)) {
                alert("Please enter vaild ASIN");
                return false
            }

            self.loader = true;
            self.viewLqsListingdata = {};
            self.viewLqsGraph = "";
            self.asin = self.inputSearchkey;
            let payload = {
                asin_id: self.inputSearchkey,
            };
            // console.log("check the azxin", payload)
            const url = "/api/global_demo/lqsstatus";
            self.$http
                .post(url, payload)
                .then((response) => {
                    // if (Object.keys(response.data.data.data).length)
                    self.viewLqsListingdata = response.data.data.data.lqs_analysis;
                    self.viewLqsGraph = response.data.data.data.total;
                    this.gaugeChart();
                    self.loader = false;
                })
                .catch((err) => {
                    self.loader = false;
                    console.log("err");
                });
        },

        gaugeChart() {
            let self = this;
            this.gaugeChartData = {
                chart: {
                    type: "gauge",
                    plotBackgroundImage: null,
                    height: 200,
                },

                title: {
                    text: "Listing Quality Score ",
                },
                credits: {
                    enabled: false,
                },
                pane: [
                    {
                        startAngle: -45,
                        endAngle: 45,
                        background: null,
                        center: ["50%", "120%"],
                        size: 300,
                    },
                ],

                exporting: {
                    enabled: false,
                },

                tooltip: {
                    enabled: false,
                },

                yAxis: [
                    {
                        min: 0,
                        max: 10,
                        minorTickPosition: "outside",
                        tickPosition: "outside",
                        labels: {
                            rotation: "auto",
                            distance: 10,
                        },
                        plotBands: [
                            {
                                from: 0,
                                to: 10,
                                color: {
                                    stops: [
                                        [0, "#fd6b2d"], //yellow
                                        [1, "#55BF3B"], //green
                                    ],
                                },
                                innerRadius: "90%",
                                outerRadius: "100%",
                            },
                            {
                                from: 0,
                                to: 4,
                                color: "#FF786B", // red
                                thickness: 20,
                            },
                            {
                                from: 4,
                                to: 8,
                                color: "#667BFE", // blue
                                thickness: 20,
                            },
                            {
                                from: 8,
                                to: 10,
                                color: "#42D9BC", // green
                                thickness: 20,
                            },
                        ],
                        pane: 0,
                        title: {
                            text: "",
                            y: 0,
                        },
                    },
                ],

                plotOptions: {
                    gauge: {
                        dataLabels: {
                            enabled: false,
                        },
                        dial: {
                            radius: "100%",
                        },
                    },
                },

                series: [
                    {
                        name: "Ratting",
                        data: [self.viewLqsGraph],
                        yAxis: 0,
                    },
                ],
            };
        },
    },
};
</script>

<style scoped>
.screenshot-btn{
    transition: .4s linear !important;
    cursor: pointer;
}

.screenshot-btn .fa-download {
    color: var(--primary_brand) !important
}

.screenshot-btn:hover {
    background-color: #F2F1F6;
}

.screenshot-hide-btn {
    visibility: hidden;
}

.space-between {
    display: flex;
    justify-content: space-between;
}

.flex-start {
    display: flex;
    justify-content: start;
}

.mainHeading {
    color: #4e4e4e;
    margin-bottom: 0;
    font-size: 1.3125rem;
}

.secondaryHeading {
    color: #4e4e4e;
    margin-bottom: 0;
    font-size: 1rem;
    font-weight: bold;
}

.textColor {
    color: #818890 !important;
}

.flex-start {
    display: flex;
    justify-content: flex-start;
}

.inputBox {
    height: 30px;
    border: 1px solid silver;
    display: flex;
    justify-content: start;
    background: white;
}

.inputBox input {
    border-radius: 0px;
    border: none !important;
}

.sideBorder {
    border-right: 1px solid #c1c1c1;
}

input:focus {
    outline: none !important;
    box-shadow: none !important;
}

.trueIcon {
    color: #64ac94 !important;
}

.falseIcon {
    color: #ff0000 !important;
}
.errorMassage {
    color: #ff0000 !important;
    font-family: "poppins";
    font-size: 11px;
    margin-top: 5px;
}

.cardButton {
    margin-left: 10px;
}

.productCart {
    display: flex;
    justify-content: space-between;
    padding: 10px;
}

.productImg {
    width: 200px;
}

.product-title {
    font-size: 18px;
}

.productImg img {
    width: 100%;
}

.graphCount {
    font-size: 24px;
    color: "#533a79";
    font-weight: 700;
}

.asinBadge {
    /* background: '#9683b3'; */
    background: "#9683b3";
}

.cross-icon {
    color: black;
    background: white;
}

.crossIcon {
    cursor: pointer;
    font-size: 8px;
}

.space-between {
    display: flex;
    justify-content: space-between;
}

thead {
    font-family: "poppins" !important;
    background: var(--background) !important;
    color: #4e4e4e !important;
    font-size: 14px;
    font-weight: bold;
    /* padding: 10px; */
    color: black;
}

tbody {
    font-family: "poppins" !important;
    font-size: 13px;
}

.pinkColor {
    background: rgb(255 185 185);
    font-weight: bold;
}

.skyColor {
    background: rgb(199 224 255);
    font-weight: bold;
}

.no-data {
    font-size: 16px;
    text-align: center;
    padding: 10px;
    color: var(--red);
}

.card {
    border-radius: 0.7rem !important;
    border: none !important;
    margin-bottom: 1rem;
}

.graphHeading {
    font-weight: 600 !important;
    font-size: 18px !important;
    color: var(--primary_brand) !important;
    letter-spacing: 0.6px !important;
    font-family: "poppins";
}

button.primarycolor {
    background: var(--primary_brand);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 5px 25px;
    border-radius: 6px;
    letter-spacing: 0.2px;
    font-weight: bold;
    font-size: 16px;
}

button.primarycolor:hover {
    color: white;
    background: var(--primary_brand-80);
    /* border: 1.6px solid var(--base_color); */
}

.customInput {
    border-radius: 5px !important;
    height: 35px !important;
    border: 1px solid rgb(228, 231, 234);
    width: 220px;
    outline: none;
}

.danger {
    border: 1px solid var(--red);
    color: var(--red) !important;
    height: 35px !important;
    width: 220px;
    background-color: var(--red-20);
    border-radius: 5px !important;
}

.danger:focus {
    border: 1px solid var(--red) !important;
}

.customInput:focus {
    border: 1px solid var(--primary_brand) !important;
}

.customInput::placeholder {
    color: var(--primary_brand-40);
}

#lqsTable {
    --border: 1px solid var(--base_color-20);
    border-radius: 10px;
    border-spacing: 0;
    border-collapse: separate;
    border: var(--border);
    overflow: hidden;
}

#lqsTable th:not(:last-child),
#lqsTable td:not(:last-child) {
    border-right: var(--border) !important;
}

#lqsTable>tbody>tr:not(:last-child)>td {
    border-bottom: var(--border) !important;
}

#lqsTable th {
    background: var(--background);
    padding: 0.6rem !important;
    font-size: 14px !important;
    border-bottom: var(--border) !important;
    font-family: "Poppins", sans-serif !important;
}

#lqsTable td {
    padding: 4px !important;
    font-size: 14px !important;
    font-family: "Heebo", sans-serif !important;
}

.singatureLogo {
    position: absolute;
    bottom: 20px;
    right: 20px;
    text-align: center !important;
}

.delete-alert {
    background-color: #ffecec !important;
    color: var(--red);
    font-size: 30px;
    width: 45px;
    height: 45px;
}

.delete-requestBtn:hover {
    background-color: #f58181 !important;
}
</style>
<style>
/* modal */
.modal-title {
    font-weight: 600 !important;
    font-family: "poppins";
}

.modal-header {
    background: var(--primary_brand-20) !important;
    color: var(--base_color);
    border: none;
    font-family: "poppins";
    border-radius: 5px 0px 0px 0px !important;
}

.modal-header .close {
    color: black !important;
    text-shadow: none !important;
    position: absolute !important;
    top: -2px;
    right: -6px;
    font-size: 30px;
    background: var(--primary_brand-10);
    opacity: inherit;
    padding: 5px 10px;
    border-radius: 25px;
}

.modal-delete-content {
    color: var(--primary_brand);
    font-size: 16px;
    margin-bottom: 5px;
    font-family: "poppins";
}

.btn-outline-danger:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: red !important;
}
</style>
